import { Settings } from 'superlikers-dynamic-forms'

import { EyeIcon, EyeOffIcon } from '@shared/components'

export const formsSettings: Settings = {
  wrapperClasses: 'relative flex flex-col gap-1.5 text-left',
  labelClasses: 'text-ink text-sm font-medium',
  errorClasses: 'text-xs text-red-600',
  helpTextClasses: 'text-muted text-xs',
  inputClasses:
    'border-border bg-paper text-ink placeholder:text-muted focus:ring-accent/40 focus:border-accent w-full rounded-xl border px-3 py-2.5 text-sm transition-shadow focus:ring-2 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50',
  passwordEyeOpenIcon: EyeIcon,
  passwordEyeCloseIcon: EyeOffIcon,
  passwordIconClasses: 'text-muted hover:text-ink absolute top-[34px] right-3 cursor-pointer transition-colors',
  checkboxWrapperClasses: 'flex items-start gap-2.5',
  checkboxInputClasses: 'accent-accent mt-0.5 size-4 shrink-0 cursor-pointer rounded',
  checkboxLabelTextClasses: 'checkbox-label-text text-ink text-sm',
  radioGroupContainerClasses: 'flex flex-col gap-2.5',
  radioItemWrapperClasses: 'flex items-start gap-2.5',
  radioItemInputClasses: 'accent-accent mt-0.5 size-4 shrink-0 cursor-pointer',
  radioItemLabelClasses: 'text-ink text-sm',
  checkboxGroupContainerClasses: 'flex flex-col gap-2.5',
  checkboxGroupItemWrapperClasses: 'flex items-start gap-2.5',
  checkboxGroupItemInputClasses: 'accent-accent mt-0.5 size-4 shrink-0 cursor-pointer rounded',
  checkboxGroupItemLabelClasses: 'text-ink text-sm'
}
